import { RewardTermsConditionComponent } from '../Post-Login/reward/reward-terms-condition/reward-terms-condition.component'
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from '../Post-Login/profile/profile.component'
import { AuthGuard } from '../shared/services/auth/auth.guard';
import { RewardCenterComponent } from '../Post-Login/reward/reward-center/reward-center.component'
import { RewardGiftCardComponent } from '../Post-Login/reward/reward-gift-card/reward-gift-card.component';
import { RewardStatementComponent } from '../Post-Login/reward/reward-statement/reward-statement.component';
const routes: Routes = [
  { path: 'account', component: ProfileComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'account/:page', component: ProfileComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard] },
  { path: 'account/reward-center', component: RewardCenterComponent },
  { path: 'account/reward-gift-card/:image', component: RewardGiftCardComponent },
  { path: 'account/reward-statement', component: RewardStatementComponent },
  { path: 'reward-terms-condition', component: RewardTermsConditionComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PostLoginRoutingModule { }
